import PropTypes from "prop-types";
import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";

const EmptyState = ({ onAddNew }) => {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg p-8 mt-6 max-w-[600px] mx-auto">
      <WebIcon
        icon="FinancialHover"
        size="large"
        className="mb-6 w-[100px] h-[100px]"
      />
      <h2 className="mb-4 heading-large whitespace-nowrap font-bold text-lighterGrey">
        No Transactions
      </h2>
      <p className="mb-8 font-normal text-bold-x text-lighterGrey">
        There are no transactions to display at the moment.
      </p>
      <Button
        text="ADD NEW TRANSACTION"
        color="primary"
        className="w-full px-6 py-3 font-medium text-white"
        customBgColor="primary"
        customTextColor="white"
        onClick={onAddNew}
      />
    </div>
  );
};

export default EmptyState;

EmptyState.propTypes = {
  onAddNew: PropTypes.func,
};
